import { createFileRoute } from "@tanstack/react-router";

import PersonDetailPage from "/src/routes/person/detail";

export const Route = createFileRoute("/_main/person/$id/view")({
  component: PersonDetailPage,
});
